import { Trans, useTranslation } from 'react-i18next';
import { useCustomHistory } from '../../router/navigation';
import {
  FlexColumn,
  FlexRow,
  PageTile,
  SvgIcon,
  useMatchMedia,
} from '@make-software/cspr-design';
import { BodyText, Link } from '@block-explorer/ui';
import React from 'react';
import { StyledButton } from '../../scenes/AccountDetailsScene';
import styled from 'styled-components';

const BannerContainer = styled(PageTile)(({ theme }) =>
  theme.withMedia({
    padding: '16px',
    width: '100%',
    margin: 0,
  })
);

export const LegacyPageBanner = ({
  title,
  newVersionLink,
}: {
  title: string;
  newVersionLink: string;
}) => {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const DynamicLayout = useMatchMedia(
    [FlexColumn, FlexRow, FlexRow, FlexRow],
    []
  );

  const redirectToNewVersion = () => {
    history.push(newVersionLink, {
      allowedGoBack: false,
    });
  };

  return (
    <BannerContainer>
      <DynamicLayout
        justify={'space-between'}
        align={'center'}
        itemsSpacing={16}
      >
        <FlexColumn itemsSpacing={8}>
          <FlexRow itemsSpacing={8} align={'center'}>
            <SvgIcon
              height={16}
              src={'assets/icons/ic-star.svg'}
              alt={'Star icon'}
              role={'img'}
            />
            <BodyText size={2}>
              <Trans t={t}>
                There is a new “{title}” page with an improved information
                architecture and layout.
              </Trans>
            </BodyText>
          </FlexRow>
          <BodyText size={3}>
            <Trans t={t}>
              Is anything missing from the new layout? We’d love your{' '}
              <Link
                color={'primaryBlue'}
                href={'https://feedback.cspr.live/'}
                rel="noopener"
              >
                feedback.
              </Link>
            </Trans>
          </BodyText>
        </FlexColumn>
        <StyledButton color="primaryBlue" onClick={redirectToNewVersion}>
          <Trans t={t}>Switch to new design</Trans>
        </StyledButton>
      </DynamicLayout>
    </BannerContainer>
  );
};

export default LegacyPageBanner;
